import React from 'react';
import { Highlight, themes } from 'prism-react-renderer';
import Copy from '../Copy/Copy';
import normalize from './normalize';

import { Prism } from 'prism-react-renderer';

import { getParams } from '../../utils/highlight';
import './extendPrism';

import './CodeBlock.scss';
import { CodeBlockProps } from '../../entities/CodeEntities';

/*
 * MDX passes the code block as JSX
 * we un-wind it a bit to get the string content
 * but keep it extensible so it can be used with just children (string) and className
 */

export default function CodeBlock({ children, className = children.props ? children.props.className : `` }: CodeBlockProps) {
  const [language] = getParams(className);
  const [content, highlights] = normalize(children.props && children.props.children ? children.props.children : children, className);
  if (content === '' && highlights === '') return;
  return (
    <Highlight code={content} language={language} theme={themes.vsLight} prism={Prism}>
      {({ tokens, getLineProps, getTokenProps, style }) => (
        <div className="gatsby-highlight codeBlock">
          <Copy content={content} />
          <pre className="pre" style={{ ...style }}>
            <code className={className}>
              {tokens.map((line, i) => {
                const lineProps = getLineProps({ line, key: i });
                const className = [lineProps.className]
                  .concat(highlights[i] && `gatsby-highlight-code-line`)
                  .filter(Boolean)
                  .join(` `);
                return (
                  <div
                    key={i}
                    {...Object.assign({}, lineProps, {
                      className,
                    })}
                  >
                    <span className="line-number">{i + 1}</span>
                    <span className="line-content">
                      {line.map((token, key) => (
                        <span key={key} {...getTokenProps({ token, key })} />
                      ))}
                    </span>
                  </div>
                );
              })}
            </code>
          </pre>
        </div>
      )}
    </Highlight>
  );
}
